var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 70,
    viewBox: "0 0 40 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.645 40.6953V70H11.1834V40.6953H0V28.8129H11.1834V24.4896C11.1834 8.43935 17.8883 0 32.0747 0C36.4238 0 37.5111 0.698965 39.8927 1.26849V13.0215C37.2263 12.5555 36.4756 12.2966 33.7056 12.2966C30.4179 12.2966 28.6575 13.2286 27.0525 15.0666C25.4475 16.9046 24.645 20.0888 24.645 24.645V28.8388H39.8927L35.8025 40.7212H24.645V40.6953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.1cfe24916992ff51958b178f07af7737.svg";
export { ForwardRef as ReactComponent };